module.exports = __webpack_public_path__ + "assets/img/paySuccess.74b78128.png";